import React from 'react';
import { Box, TextField, Autocomplete, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { CityDataNew } from '../data/cityData';

const EnhancedSearchBar = ({ onIdSearch, onCitySearch, onFromDateSearch, onToDateSearch }) => {
    return (
        <Box mb={2}>
            <Box 
                display="flex" 
                gap={2} 
                mb={2}
                sx={{
                    flexDirection: { xs: 'column', sm: 'row' },
                    '& .MuiTextField-root': {
                        minWidth: { xs: '100%', sm: 'auto' }
                    }
                }}
            >
                <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Search by ID..."
                    onChange={(e) => onIdSearch && onIdSearch(e.target.value)}
                    InputProps={{
                        startAdornment: <SearchIcon sx={{ color: '#D32F2F', mr: 1 }} />,
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#D32F2F',
                            },
                            '&:hover fieldset': {
                                borderColor: '#B71C1C',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#D32F2F',
                            },
                        },
                    }}
                />
                <Autocomplete
                    options={CityDataNew}
                    filterOptions={(options, { inputValue }) =>
                        options.filter((option) =>
                            option.toLowerCase().startsWith(inputValue.toLowerCase())
                        )
                    }
                    sx={{
                        width: { xs: '100%', sm: 300 },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#D32F2F',
                            },
                            '&:hover fieldset': {
                                borderColor: '#B71C1C',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#D32F2F',
                            },
                        },
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="Select City"
                            InputProps={{
                                ...params.InputProps,
                                startAdornment: <SearchIcon sx={{ color: '#D32F2F', mr: 1 }} />,
                            }}
                        />
                    )}
                    onChange={(event, newValue) => {
                        onCitySearch && onCitySearch(newValue);
                    }}
                />
            </Box>
            
            {/* Date Filter Row */}
            <Box 
                display="flex" 
                gap={2} 
                alignItems="center" 
                mb={2}
                sx={{
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'stretch', sm: 'center' },
                    '& .MuiTextField-root': {
                        minWidth: { xs: '100%', sm: 'auto' }
                    }
                }}
            >
                <Typography 
                    variant="body1" 
                    fontWeight="bold" 
                    color="#000000"
                    sx={{ 
                        textAlign: { xs: 'center', sm: 'left' },
                        mb: { xs: 1, sm: 0 }
                    }}
                >
                    Filter by Expiry Date:
                </Typography>
                <TextField
                    type="date"
                    label="From Date"
                    variant="outlined"
                    size="small"
                    onChange={(e) => onFromDateSearch && onFromDateSearch(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        startAdornment: <CalendarTodayIcon sx={{ color: '#D32F2F', mr: 1 }} />,
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#D32F2F',
                            },
                            '&:hover fieldset': {
                                borderColor: '#B71C1C',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#D32F2F',
                            },
                        },
                    }}
                />
                <TextField
                    type="date"
                    label="To Date"
                    variant="outlined"
                    size="small"
                    onChange={(e) => onToDateSearch && onToDateSearch(e.target.value)}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    InputProps={{
                        startAdornment: <CalendarTodayIcon sx={{ color: '#D32F2F', mr: 1 }} />,
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#D32F2F',
                            },
                            '&:hover fieldset': {
                                borderColor: '#B71C1C',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#D32F2F',
                            },
                        },
                    }}
                />
            </Box>
        </Box>
    );
};

export default EnhancedSearchBar; 